import React, { memo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Input, message, Modal, Row, Select, Space } from 'antd'
import { DOCUMENT_TYPE } from '../../constants'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import validator from './../../validator'

const AuthoritiesActionModal = props => {
  const {
    payloadModal,
    handleCloseModal,
    authorityStore,
    handleSetValueFilter,
    tabActive,
  } = props

  const [form] = Form.useForm()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!payloadModal.updatePayLoad) return
    form.setFieldsValue({
      type: payloadModal.updatePayLoad.type,
      name: payloadModal.updatePayLoad.name.replace(/\s+/g, ' ').trim(),
    })
  }, [payloadModal])

  useEffect(() => {
    if (payloadModal.isCreate) {
      form.setFieldsValue({
        type: tabActive,
      })
    }
  }, [tabActive])

  const onFinish = async values => {
    try {
      let messageSuccess
      setIsLoading(true)
      if (payloadModal.isCreate) {
        await authorityStore.createAuthority(values)
        messageSuccess = 'Tạo cơ quan ban hành thành công!'
      } else {
        await authorityStore.updateAuthority(
          payloadModal.updatePayLoad?.id,
          values
        )
        messageSuccess = 'Chỉnh sửa cơ quan ban hành thành công!'
      }
      await authorityStore.getAuthorityIssueds()
      handleSetValueFilter && handleSetValueFilter(payloadModal.isCreate)
      handleCancel()
      message.success(messageSuccess)
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    handleCloseModal()
    setTimeout(() => {
      form.resetFields()
    }, 100)
  }

  return (
    <Modal
      visible={payloadModal.status}
      footer={null}
      onCancel={handleCancel}
      wrapClassName="custom-modal-wrapper"
      title={
        payloadModal.isCreate
          ? 'Tạo mới cơ quan ban hành'
          : 'Chỉnh sửa cơ quan ban hành'
      }>
      <Form
        form={form}
        layout={'vertical'}
        onFinish={onFinish}
        initialValues={{
          type: tabActive,
        }}>
        <Form.Item
          name="type"
          label="Loại cơ quan ban hành"
          rules={[{ required: true, message: 'Vui lòng chọn loại văn bản!' }]}>
          <Select
            disabled={
              !payloadModal.isCreate || props.disabledAuthoritiesTypePicker
            }
            className="h-40">
            <Select.Option value={DOCUMENT_TYPE.INCOMING}>
              Văn bản đến
            </Select.Option>
            <Select.Option value={DOCUMENT_TYPE.OUTGOING}>
              Văn bản đi
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={'Tên cơ quan ban hành'}
          name={'name'}
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập tên cơ quan ban hành!',
            },
            { validator: validator.validateInputString },
          ]}>
          <Input placeholder={'Nhập tên cơ quan ban hành'} className="h-40" />
        </Form.Item>
        <div className="custom-modal-footer">
          <Button onClick={handleCancel} className="custom-ant-button w-160">
            Hủy
          </Button>
          <Button
            type={'primary'}
            htmlType={'submit'}
            loading={isLoading}
            className="custom-ant-button w-160">
            {payloadModal.isCreate ? 'Tạo mới' : 'Cập nhật'}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

AuthoritiesActionModal.propTypes = {
  payloadModal: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  handleSetValueFilter: PropTypes.func,
  disabledAuthoritiesTypePicker: PropTypes.bool,
}

export default memo(
  withRouter(
    inject(
      'loadingAnimationStore',
      'authenticationStore',
      'authorityStore',
      'commonStore'
    )(observer(AuthoritiesActionModal))
  )
)
